type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | ClassValue[]
  | { [key: string]: unknown };

function cx(...args: ClassValue[]): string {
  const classes: string[] = [];

  args.forEach(arg => {
    if (!arg) return;
    if (typeof arg === 'string' || typeof arg === 'number') {
      classes.push(String(arg));
    } else if (Array.isArray(arg)) {
      classes.push(cx(...arg));
    } else if (typeof arg === 'object') {
      for (const key in arg) {
        if (arg[key]) classes.push(key);
      }
    }
  });

  return classes.join(' ');
}

export default cx;
